module.exports = __webpack_public_path__ + "static/img/10.17efe43b.png";